import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { StoreService } from "../services/store-service";

interface TabState {
  activeTab: "home" | "appointments" | "profile";
  selectedService: string | null;
  selectedStylist: string | null;
}

const currentPath = window.location.pathname;

const pathBasedTab: "home" | "appointments" | "profile" = currentPath.includes(
  "/profile"
)
  ? "profile"
  : currentPath.includes("/times")
  ? "appointments"
  : "home";

const storedTab = StoreService.GetData("activeTab") as
  | "home"
  | "appointments"
  | "profile"
  | null;

const isValidStoredTab =
  (storedTab === "profile" && currentPath.includes("/profile")) ||
  (storedTab === "appointments" && currentPath.includes("/times")) ||
  (storedTab === "home" && currentPath.includes("/main"));

const initialState: TabState = {
  activeTab: isValidStoredTab ? storedTab! : pathBasedTab,
  selectedService: null,
  selectedStylist: null,
};

const tabSlice = createSlice({
  name: "tabs",
  initialState,
  reducers: {
    setActiveTab(state, action: PayloadAction<TabState["activeTab"]>) {
      if (state.activeTab !== action.payload) {
        state.activeTab = action.payload;
        StoreService.SetData("activeTab", action.payload);
      }
    },
    setSelectedService(state, action: PayloadAction<string | null>) {
      state.selectedService = action.payload;
    },
    setSelectedStylist(state, action: PayloadAction<string | null>) {
      state.selectedStylist = action.payload;
    },
  },
});

export const {
  setActiveTab,
  setSelectedService,
  setSelectedStylist,
} = tabSlice.actions;

export default tabSlice.reducer;
